import UserContent from "./UserContent";
import "./UserContent.scss";

export default UserContent;